<template>
  <div class="mb-4 flex flex-col items-center justify-between gap-3">
    <h1 class="m-auto mt-2 text-center font-serif text-4xl font-bold md:mt-10 md:text-4.5xl">
      {{ t("pages.profile-shop.title") }}
    </h1>

    <p class="text-center text-sm text-gray-500">
      {{ t("pages.profile-shop.welcome") }} <br />
      {{ t("pages.profile-shop.learn_more.text") }}
      <a href="https://www.imagen-ai.com/" class="text-theme-3 hover:text-theme-3b">
        {{ t("pages.profile-shop.learn_more.about") }}
      </a>
    </p>

    <div class="flex flex-row gap-4">
      <IAILink
        v-for="link in links"
        :key="link.label"
        :href="link.href"
        :text="link.label"
        variant="bold"
        :target="link.target"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { t } from "@/locales/vue";
import { IAILink } from "@/core-ui-vue";
import { ASK_TO_BE_A_SELLER_URL, SUGGEST_A_STYLE_URL } from "@/features/profile-shop/utils";

const links = [
  {
    label: t("pages.profile-shop.links.ask-to-be-a-seller"),
    href: ASK_TO_BE_A_SELLER_URL,
    target: "_blank",
  },
  {
    label: t("pages.profile-shop.links.faqs"),
    href: "/profile-shop/faqs",
    target: "_self",
  },
  {
    label: t("pages.profile-shop.links.suggest-a-style"),
    href: SUGGEST_A_STYLE_URL,
    target: "_blank",
  },
];
</script>
